import React, { useEffect, useState } from 'react';
import {
  PageHeader, Panel, Switch, Spinner, EmptyState, Banner, Button, useCkToast,
} from '@NP-Webber/crm-kit/dist/next/index.js';
import api from '../../services/api.js';
import { apiError } from '../../next/ui';

/** דגלי פיצ'ר — new design. Same endpoints as FeatureFlags (/feature-flags). */
export default function FeatureFlagsNext() {
  const toast = useCkToast();
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState(null);

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const { data } = await api.get('/feature-flags');
      setFlags(data.data || []);
    } catch (e) {
      setError(apiError(e, 'שגיאה בטעינה'));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const toggle = async (flag) => {
    setBusyId(flag._id);
    try {
      const { data } = await api.put(`/feature-flags/${flag._id}`, { enabled: !flag.enabled });
      setFlags((prev) => prev.map((f) => (f._id === data._id ? data : f)));
      toast.success(`${flag.key} ${data.enabled ? 'הופעל' : 'כובה'}`);
    } catch (e) {
      toast.error(apiError(e, 'שגיאה בעדכון'));
    } finally {
      setBusyId(null);
    }
  };

  const on = flags.filter((f) => f.enabled).length;
  return (
    <div className="nx-stack nx-narrow">
      <PageHeader title="דגלי פיצ'ר" sub={`הפעלה וכיבוי של יכולות במערכת — השינוי חל מיד · ${on} מתוך ${flags.length} פעילים`} />
      {error ? <Banner tone="danger" icon="alert" action={<Button size="sm" onClick={load}>נסו שוב</Button>}>{error}</Banner> : null}
      <Panel title="יכולות" icon="flag" flush>
        {loading ? <div className="ck-empty"><Spinner size={24} /></div> : flags.length ? (
          <div className="nx-tree">
            {flags.map((flag) => (
              <div key={flag._id} className="nx-tree__row" style={{ padding: '6px 14px' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Switch
                    label={<span className="nx-code" style={{ fontSize: 13.5 }}>{flag.key}</span>}
                    hint={flag.description}
                    checked={!!flag.enabled}
                    disabled={busyId === flag._id}
                    onChange={() => toggle(flag)}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : <EmptyState compact icon="flag" title="אין דגלים" />}
      </Panel>
    </div>
  );
}
